import { NeoModel} from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';

@NeoModel
export default class FileDownloadComponentVM extends Views.ViewModelBase {
    notifications: any;
    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }

    public async initialise() {
    }
}